<template>
  <label
    :for="id + '_button'"
    :class="{ active: isActive }"
    class="toggle__button"
  >
    <input
      type="checkbox"
      :disabled="disabled"
      :id="id + '_button'"
      v-model="checkedValue"
    />
    <span class="toggle__switch" :class="color"></span>
  </label>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'brand',
    },
    labelDisableText: {
      type: String,
      default: 'Off',
    },
    id: {
      type: String,
      default: 'primary',
    },
    value: {
      type: [Number, Boolean, String],
      default: true,
    },
  },
  computed: {
    isActive() {
      return !!Number(this.value);
    },
    disabledText() {
      return this.labelDisableText;
    },
    checkedValue: {
      get() {
        return !!Number(this.value);
      },
      set(newValue) {
        this.$emit('input', newValue);
        this.$emit('change', newValue);
      },
    },
  },
};
</script>
